<m27-dialog #modal class="dialog-login-component">
  <m27-dialog-header [showClose]="false" [allowMaxSize]="false" (onClose)="isBackButtonEnabled() ? close('Cancel') : closeAll()">
    <div class="title">
      <span>
        <i class="fa fa-unlock-alt"></i>
        Application Login
      </span>
    </div>
  </m27-dialog-header>
  <m27-dialog-body>
    <div style="display: inline-block; width: 100%">
      <div class="dialog-icon lock"></div>
      <div style="float: left; margin-left: 2px;" class="verbiage">
        <div class="first-line">Click the button below to log in to the application.</div>
        <div class="the-rest">You may be prompted for your Corteva&trade; credentials.</div>
      </div>
    </div>
  </m27-dialog-body>
  <m27-dialog-footer>
    <div class="dialog-buttons-right">
      <button class="button success" automationid="userLoginDialog" [autofocus]="true" (click)="login()">
        Login
      </button>
    </div>
  </m27-dialog-footer>
</m27-dialog>
